import React from 'react';
import Icon from 'components/Icon';
import colors from 'assets/styles/jsVariables/colors';
import { parseHashString } from 'libs/common';

import './SignupSuccess.scss';

const link = '<a href="https://choosemuse.com/contactsupport" class="SignupSuccess__LinkText">https://choosemuse.com/contactsupport</a>';

const translations = {
  en: {
    title: 'Thank you!',
    description1: 'Your email address has been successfully verified.',
    description2: 'If you have questions and concerns, contact <a href="https://choosemuse.com/contact/" class="SignupSuccess__LinkText"> Customer Care</a>'
  },
  fr: {
    title: 'Merci!',
    description1: 'Vous pouvez maintenant revenir à votre application Muse et vous connecter à votre compte.',
    description2: `Si vous avez des questions et des préoccupations, contactez le service à la clientèle au <div>${link}</div>`
  },
  es: {
    title: '¡Gracias!',
    description1: 'Ahora puede volver a su aplicación Muse e iniciar sesión en su cuenta.',
    description2: `Si tiene alguna pregunta o inquietud, comuníquese con atención al cliente al <div>${link}</div>`
  },
  de: {
    title: 'Vielen Dank!',
    description1: 'Sie können jetzt zu Ihrer Muse App zurückkehren und sich bei Ihrem Konto anmelden.',
    description2: `Wenn Sie Fragen und Bedenken haben, wenden Sie sich an die Kundenbetreuung unter <div>${link}</div>`
  },
  it: {
    title: 'Grazie!',
    description1: 'Ora puoi tornare alla tua app Muse e accedere al tuo account.',
    description2: `In caso di domande e dubbi, contattare l'assistenza clienti a <div>${link}</div>`
  },
  ja: {
    title: 'ありがとうございました！',
    description1: 'これであなたのMuseアプリに戻り、あなたのアカウントにログインできます。',
    description2: `<div>ご不明な点がございましたら、</div><div>${link} までご連絡ください。</div>`
  }
};

function SignupSuccess() {
  const parsedHash = parseHashString();
  const locale = Object.keys(parsedHash)[0];
  console.log('sign up success', parsedHash, locale);
  const translatedText = translations[locale] || translations.en;
  return (
    <center>
      <div className="SignupSuccess">
        <Icon
          name="check-circle"
          fill={colors.lighterGreen}
          style={{
            height: 45,
            width: 45,
            stroke: colors.lighterGreen,
            strokeWidth: '0.7px'
          }}
        />
        <div className="SignupSuccess__Heading">{translatedText.title}</div>
        <div className="SignupSuccess__Body">
          <div>
            {translatedText.description1}
          </div>
          <div style={{ marginTop: 24 }}>
            <div dangerouslySetInnerHTML={{ __html: translatedText.description2 }} />
          </div>
        </div>
      </div>
    </center >
  );
}

export default SignupSuccess;



// WEBPACK FOOTER //
// ./src/views/SignupSuccess/SignupSuccess.jsx